// extracted by mini-css-extract-plugin
module.exports = {"styledDropdown":"jHRwvxb1"};